import React from 'react';
import { injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

import { BMC_STAGES } from '../common_components/bmc/bmc_constants';
import { SUGGESTS, VISION_SUGGESTS } from './common/SuggestsConstant';
import SuggestCard from './SuggestCard';
import VisionCard from './VisionCard';

import { FormControl, FormGroup, ControlLabel } from 'react-bootstrap';

//@inject('suggestStore')
@observer
class BlockSuggestBody extends React.Component {
  constructor(props) {
    super(props);

    //props.suggestStore.loadMvpBmc('MVP1');
    this.state = {
      option: 'predefined'
    };
  }

  setOption(opt) {
    this.setState({ option: opt });
    this.props.suggestStore.loadMvpBmc(opt);
    if (opt === 'vision')
      this.props.suggestStore.rootStore.setLoadingAndFetchVisionData();
  }

  render() {
    const { blockStore, intl, suggestStore } = this.props;
    let suggests = [];

    // currently vision's bmc use only observation station for suggestions,
    // it use the same structure as the rest of the suggestion for compatibility and expandability reasons.
    //if (blockStore.rootStore.isBmcVision) {
    /* if (blockStore.rootStore.isBmcVision) {
            if (VISION_SUGGESTS[blockStore.name] && VISION_SUGGESTS[blockStore.name][BMC_STAGES.OBSERVATIONAL]) {
                suggests = VISION_SUGGESTS[blockStore.name][BMC_STAGES.OBSERVATIONAL];
            }
        } else if (SUGGESTS[blockStore.name] && SUGGESTS[blockStore.name][blockStore.rootStore.currentStage]) {
            suggests = SUGGESTS[blockStore.name][blockStore.rootStore.currentStage];
        }*/

    // if (!suggests.length) {
    //     return null;
    // }

    let options = ['predefined'];
    let cards = [];

    if (blockStore.rootStore.isBmcVision) {
      if (
        VISION_SUGGESTS[blockStore.name] &&
        VISION_SUGGESTS[blockStore.name][BMC_STAGES.OBSERVATIONAL]
      ) {
        suggests = VISION_SUGGESTS[blockStore.name][BMC_STAGES.OBSERVATIONAL];
      }
    } else {
      options.push(...['vision'], ...Object.keys(suggestStore.mvps));
      options = options.filter(e => blockStore.rootStore.boardableName !== e);

      //console.log(suggestStore.loadedData)
      switch (this.state.option) {
        case 'vision':
          cards = blockStore.getVisionCards;
          break;
        case 'predefined':
          if (
            SUGGESTS[blockStore.name] &&
            SUGGESTS[blockStore.name][blockStore.rootStore.currentStage]
          ) {
            suggests =
              SUGGESTS[blockStore.name][blockStore.rootStore.currentStage];
          }
          break;
        default:
          cards = suggestStore.getCardsByBlock(
            this.state.option,
            blockStore.name
          );
          break;
      }
    }

    return (
      <div className="">
        {' '}
        {
          <FormGroup controlId="formControlsSelect">
            <FormControl
              componentClass="select"
              value={this.state.option}
              onChange={e => this.setOption(e.target.value)}
            >
              {' '}
              {options.map((e, idx) => (
                <option value={e.toString()} key={idx}>
                  {' '}
                  {e == 'vision' || e == 'predefined'
                    ? this.props.intl.formatMessage({ id: e })
                    : e}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        }
        {suggestStore.loadedData ||
        this.state.option === 'predefined' ||
        (this.state.option === 'vision' &&
          blockStore.rootStore.isVisionBmcLoaded) ? (
          <ul className="cards-list list-unstyled">
            {' '}
            {suggests.map(c => (
              <SuggestCard key={c.id} card={c} blockStore={blockStore} />
            ))}
            {cards.map(c => (
              <VisionCard key={c.id} card={c} blockStore={blockStore} />
            ))}
          </ul>
        ) : (
          <div className="main-loader">
            <div className="loader-lg"></div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(BlockSuggestBody);
